import {ref, computed, onUnmounted} from "vue";
import {useStore} from "vuex";
import Pusher from "pusher-js";


const apiKey = process.env.MIX_PUSHER_API_KEY;

export const useSocketActivation = () => {
    const store = useStore();

    const localStorageData = JSON.parse(localStorage.getItem('user-data')) ?? null
    const accountKey = computed(() => (store.state.user.userData?.account_key || localStorageData?.account_key) ?? null);

    let pusher = null;
    let channel = null;
    let currentChannelName = null;
    const socketResponse = ref()

    const activate = () => {
        if (!apiKey) {
            console.warn("[Pusher] Missing apiKey");
            return false;
        }

        if (pusher) return true;

        try {
            pusher = new Pusher(apiKey, {
                cluster: "eu",
                forceTLS: true,
            });

            pusher.connection.bind("connected", () => console.log("[Pusher] connected"));
            pusher.connection.bind("disconnected", () => console.log("[Pusher] disconnected"));
            pusher.connection.bind("error", (err) => console.error("[Pusher] connection error", err));

            return true;
        } catch (e) {
            console.error("[Pusher] activation failed", e);
            pusher = null;
            return false;
        }
    };

    const bindChannelEvents = (ch) => {
        ch.bind("pusher:subscription_succeeded", (data) => {
            console.log("[Pusher] subscription_succeeded", {channel: ch.name, data});
        });

        ch.bind("pusher:subscription_error", (data) => {
            console.error("[Pusher] subscription_error", {channel: ch.name, data});
        });

        ch.bind("activation", (data) => {
            console.log("[Pusher] activation", {channel: ch.name, data});
            socketResponse.value = data
        });
    };

    const subscribe = (channelName = accountKey.value) => {
        if (!channelName) {
            console.warn("[Pusher] Missing accountKey for subscribe", accountKey.value);
            return false;
        }

        if (!pusher && !activate()) return false;

        if (channel && currentChannelName === channelName) return true;

        if (channel && currentChannelName && currentChannelName !== channelName) {
            unsubscribe();
        }

        try {
            channel = pusher.subscribe(channelName);
            currentChannelName = channelName;
            bindChannelEvents(channel);
            return true;
        } catch (e) {
            console.error("[Pusher] subscribe failed", e);
            channel = null;
            currentChannelName = null;
            return false;
        }
    };

    const unsubscribe = () => {
        if (!pusher || !currentChannelName) return;

        try {
            if (channel) channel.unbind_all();

            pusher.unsubscribe(currentChannelName);

            channel = null;
            currentChannelName = null;

            console.log("[Pusher] unsubscribed");
        } catch (e) {
            console.error("[Pusher] unsubscribe failed", e);
        }
    };

    const disconnect = () => {
        try {
            unsubscribe();

            if (pusher) {
                pusher.disconnect();
                pusher = null;
            }

            console.log("[Pusher] disconnected (manual)");
        } catch (e) {
            console.error("[Pusher] disconnect failed", e);
        }
    };

    onUnmounted(() => {
        disconnect()
    })

    return {
        // state
        accountKey,
        socketResponse,

        // actions
        activate,
        subscribe,
        unsubscribe,
        disconnect,
    };
};
